import { dataIndent } from 'dls-icons-data'
import { createIcon } from '../common'

const IconIndent = /*#__PURE__*/createIcon(dataIndent)
export default IconIndent
